var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper-student-preview-not-match"},[_c('TemplateDataGrid',_vm._b({attrs:{"gridId":"PePaperStudentQueryNotMatch"}},'TemplateDataGrid',_vm.gridParams,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }